import { ScreenRoot, SettingsRoot } from "types";

export const SettingsRootDefinition: ScreenRoot = {
  name: SettingsRoot,
  routePath: ["/settings/*"],
  accessPath: "miscellaneous.ownUserSettings",
};
